import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeroBannerComponent} from './components/hero-banner/hero-banner.component';
import {LibUtilsModule} from '@utils/lib-utils.module';
import {MatDialogModule} from '@angular/material/dialog';
import {LibDialogsModule} from '../dialogs/lib-dialogs.module';
import {RouterModule} from '@angular/router';
import { AboBannerComponent } from './components/abo-banner/abo-banner.component';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [
    HeroBannerComponent,
    AboBannerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    LibUtilsModule,
    LibDialogsModule,
    MatDialogModule,
    MatIconModule,
  ],
  exports: [
    HeroBannerComponent,
    AboBannerComponent,
  ]
})
export class LibBannersModule { }
